<template>
    <div
        v-if="$validateText(text)" 
        v-tooltip="{
            content: text,
            trigger: eventListeners,
        }"
        class="d-inline-block"
    >
        <slot>
            <i 
                class="bi bi-info-circle-fill text-info" 
                :class="iconClass"    
            />  
        </slot>
    </div>
</template>

<script>
export default {
    props: {
        text: {
            type: String,
            required: false,
            default: ''
        },
        iconClass: {
            type: String,
            required: false,
            default: ''
        }
    },
    data() {
        return {
            isDesktop: null
        };
    },
    computed: {
        eventListeners() {
            return this.isDesktop 
                ? 'hover click'
                : 'click';
        },
    },
    beforeMount() {
        this.isDesktop = window.innerWidth > 768;
    }    
};
</script>